module.exports = __webpack_public_path__ + "static/img/mc.58583480.svg";